import * as fromPDNctions from '../../../actions/AdmMapa/DatosNISOUC/PanelNISOUC.actions';


export interface PDNistate {
    PanelActivo: boolean;
    Nis:string;
}

const initialStatePDNis: PDNistate = {
    PanelActivo: false,
    Nis: ''
};

export function PDNisReducer(state = initialStatePDNis, action: fromPDNctions.PanelDNActions): PDNistate {
    switch (action.type) {
        case fromPDNctions.VISUALIZAR_DN:
            return {
                ...state,
                PanelActivo: true,
                Nis: action.Nis
            };
        case fromPDNctions.OCULTAR_DN:
            return {
                ...state,
                PanelActivo: false,
                Nis: ''
            };
      default: {
        return state;
      }
    }
}